import { render, staticRenderFns } from "./pWareList.vue?vue&type=template&id=6fc96b04&scoped=true&"
import script from "./pWareList.vue?vue&type=script&lang=js&"
export * from "./pWareList.vue?vue&type=script&lang=js&"
import style0 from "./pWareList.vue?vue&type=style&index=0&id=6fc96b04&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc96b04",
  null
  
)

export default component.exports